import {EventEmitter, Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {AppCb, AppCc, AppWeb} from '@app/core/models/app';
import {ExtensionDevice} from '@app/core/models/misc';

@Injectable({
  providedIn: 'root'
})
export class EventHelperService {

  // public untilChanged = new EventEmitter<number>(); // the eventEmitter way
  public untilChanged = new Subject<number>();
  public extensionChanged = new Subject<ExtensionDevice>();

  public addAppsChanged = new Subject<(AppCb|AppCc|AppWeb)[]>();


  constructor() { }


}
